<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'usersCrud'"
          :crudName="$t('city.crud.title')"
          :newText="$t('city.crud.newText')"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="$hasAbility('cadastro.gerenciar')"
          :enableEdit="$hasAbility('cadastro.gerenciar')"
          :enableDelete="$hasAbility('cadastro.gerenciar')"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "citiesTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "name", "uf_id", "uf_code", "code", "status", "actions"],
      tableData: ["id", "name", "uf_id", "uf_code", "code", "status"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "uf_id", "uf_code", "status", "code"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('city.crud.headings.id'),
          name: this.$t('city.crud.headings.name'),
          uf_id: this.$t('city.crud.headings.ufId'),
          uf_code: this.$t('city.crud.headings.ufCode'),
          code: this.$t('city.crud.headings.code'),
          status: this.$t('common.status'),
          actions: this.$t('common.actions'),
        },
        sortable: ["id", "name", "uf_id", "uf_code", "status", "code"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: this.$t('city.crud.filterBy'),
          defaultOption: this.$t('common.select'),
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: this.$t('common.active'),
            },
            {
              id: 0,
              text: this.$t('common.inactive'),
            },
          ],
        },
        templates: {
          uf_id: (h, row, index) => {
            return row.uf ? row.uf.name : this.$t('city.crud.noUfName');
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["uf"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "cities",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        uf_id: "uf[name]",
        uf_code: "uf_code",
        code: "code",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>